import React from "react";
import { StarIcon } from "@heroicons/react/24/solid";

const StarReview = ({ rate }) => {
  const rating = parseFloat(rate) || 0;

  const stars = Array.from({ length: 5 }, (_, index) => {
    const starValue = index + 1;

    if (rating >= starValue) {
      return "full";
    } else if (rating >= starValue - 0.5) {
      return "half";
    } else {
      return "empty";
    }
  });

  return (
    <div className="flex items-center">
      <div className="flex space-x-1">
        {stars.map((starType, index) => (
          <div key={index} className="relative">
            {starType === "full" && (
              <StarIcon className="w-3 h-3 lg:h-5 lg:w-5 text-custom-yellow" />
            )}
            {starType === "half" && (
              <div className="relative">
                <StarIcon className="w-3 h-3 text-gray-300 lg:h-5 lg:w-5" />
                <div
                  className="absolute top-0 left-0 overflow-hidden"
                  style={{ width: "50%" }}
                >
                  <StarIcon className="w-3 h-3 lg:h-5 lg:w-5 text-custom-yellow" />
                </div>
              </div>
            )}
            {starType === "empty" && (
              <StarIcon className="w-3 h-3 text-gray-300 lg:h-5 lg:w-5" />
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default StarReview;
